import type { IntegrationConfig } from '@repo/api-gw-sdk';
import { IntegType } from '@repo/api-gw-sdk';

import {
  integrationWizardFlow,
  type IntegrationWizardState,
} from './integrationWizardFlow';

import { Wizard } from '../../wizard/Wizard';
import { IntegrationVendor, integTypeToVendorMap } from '../types';

export const IntegrationWizard = (props: {
  entity: IntegrationConfig;
  onSave: (integration: IntegrationConfig) => Promise<void>;
  onAbort: () => void;
}) => {
  const toIntegType = (vendor: IntegrationVendor | undefined): IntegType => {
    const map: Partial<Record<IntegrationVendor, IntegType>> = {
      [IntegrationVendor.BIGQUERY]: IntegType.INTEGRATION_TYPE_BIGQUERY,
      [IntegrationVendor.SNOWFLAKE]: IntegType.INTEGRATION_TYPE_SNOWFLAKE,
      [IntegrationVendor.DATABRICKS]: IntegType.INTEGRATION_TYPE_DATABRICKS,
      [IntegrationVendor.MICROSOFT_FABRIC]:
        IntegType.INTEGRATION_TYPE_MICROSOFT_FABRIC,
      [IntegrationVendor.AMAZON_REDSHIFT]: IntegType.INTEGRATION_TYPE_REDSHIFT,
    };
    return vendor
      ? (map[vendor] ?? IntegType.INTEGRATION_TYPE_BIGQUERY)
      : IntegType.INTEGRATION_TYPE_BIGQUERY;
  };

  const save = async (state: IntegrationWizardState) => {
    const integration: IntegrationConfig = {
      id: state.id,
      name: state.name,
      enabled: state.enabled,
      type: toIntegType(state.vendor),
      config: {
        ...state.config,
        resourceSharing: {
          resourceIds: state.config?.resourceSharing?.resourceIds ?? [],
        },
      },
    };
    await props.onSave(integration);
    return true;
  };

  return (
    <Wizard<IntegrationWizardState>
      hideBackArrow={true}
      onAbort={props.onAbort}
      onFinish={save}
      initialStep={{ stepIndex: props.entity.id ? 1 : 0 }}
      flow={[integrationWizardFlow]}
      initialState={{
        ...props.entity,
        config: props.entity.config || {},
        vendor: props.entity.type
          ? (integTypeToVendorMap[props.entity.type] ??
            IntegrationVendor.UNKNOWN)
          : IntegrationVendor.UNKNOWN,
      }}
      title={props.entity.id ? `Edit integration` : `Create integration`}
    />
  );
};
